module.exports = __webpack_public_path__ + "img/img-logo.8f1d6dcb.svg";